module.exports = __webpack_public_path__ + "img/poster_id_yg.3f0b9d56.png";